<script setup lang="ts">
  import { computed } from 'vue'
  import { useRoute } from 'vue-router'
  import { storeToRefs } from 'pinia'

  import { useSubjectResource } from '@/composables/useSubjectResource'
  import RouteParam from '@/enums/RouteParam'
  import { parseSlug } from '@/utils'
  import { useAuthStore } from '@/stores/auth'

  import AppLayout from '@/components/layout/AppLayout.vue'
  import AssignmentSet from '@/components/task/AssignmentSet.vue'
  import AssignmentSetSkeleton from '@/components/skeletons/AssignmentSetSkeleton.vue'
  import NavigateBackwardsLink from '@/components/layout/NavigateBackwardsLink.vue'
  import StandardLayout from '@/components/layout/Layout.vue'
  import AssignmentCollectionTopSection from '@/components/AssignmentCollectionTopSection.vue'

  const { params } = useRoute()
  const { isTeacher } = storeToRefs(useAuthStore())

  const { assignmentSets, subjectResourceCategory, subjectResourceTitle, subjectResourceIntroduction, resourceGuide } = useSubjectResource()

  const cumulativeIndex = computed(() => {
    let index = 0

    return assignmentSets.value.map(assignmentSet => {
      const newIndex = index
      index += assignmentSet.assignmentContentIds?.length ?? 0
      return newIndex
    })
  })

  const navigateBackwardsText = parseSlug(params[RouteParam.Topic] as string)
</script>

<template>
  <StandardLayout>
    <NavigateBackwardsLink :button-text="navigateBackwardsText" />
    <AppLayout>
      <AssignmentCollectionTopSection
        :is-teacher="isTeacher"
        :subject-resource-category="subjectResourceCategory"
        :subject-resource-title="subjectResourceTitle"
        :subject-resource-introduction="subjectResourceIntroduction"
        :resource-guide="resourceGuide"
      />
      <div class="assignment-collection">
        <template v-if="!assignmentSets.length">
          <AssignmentSetSkeleton />
          <AssignmentSetSkeleton />
        </template>
        <AssignmentSet
          v-for="(assignmentSet, i) in assignmentSets"
          v-else
          :key="i"
          :assignment-set="assignmentSet"
          :index="cumulativeIndex[i] + 1"
        />
      </div>
    </AppLayout>
  </StandardLayout>
</template>

<style scoped lang="scss">
  .assignment-collection {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }
</style>
